import { render, staticRenderFns } from "./order_confirmNoLogin.vue?vue&type=template&id=5a9522d4&scoped=true"
import script from "./order_confirmNoLogin.vue?vue&type=script&lang=js"
export * from "./order_confirmNoLogin.vue?vue&type=script&lang=js"
import style0 from "./order_confirmNoLogin.vue?vue&type=style&index=0&id=5a9522d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9522d4",
  null
  
)

export default component.exports